import { useQuery } from "@tanstack/react-query";

import { BreadcrumbsController } from "../../../api/breadcrumbsController";
import { QUERY_KEYS } from "../../../api/queries";

export function useMapSettings() {
	return useQuery({
		queryFn: () => BreadcrumbsController.getSettings(),
		queryKey: [QUERY_KEYS.Maps.MapSettings],
	});
}
